
<!-- task-drawer.component.html -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="720" [nzVisible]="isVisible"
  [nzTitle]="data != null  ? 'Edit Task' : 'Create New Task'" [nzFooter]="footerTpl" (nzOnClose)="closeonly()"
  [nzSize]="'default'">
  <form nz-form nzLayout="horizontal" *nzDrawerContent [formGroup]="taskForm">
    <!-- Project ID -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzRequired>Project</nz-form-label>
      <nz-form-control [nzSpan]="18" nzErrorTip="Please select at least one project">
        <nz-select [nzDisabled]="disabledProject" nzPlaceHolder="Select Projects" nzAllowClear nzShowSearch
          nzServerSearch formControlName="task_project" (nzOnSearch)="onSearchProject($event)">
          @if (!loadingProject) {
          @for (project of listOfProject; track project.id) {
          <nz-option [nzValue]="project.id" [nzLabel]="project.name"></nz-option>
          }
          } @else {
          <nz-option nzDisabled nzCustomContent>
            <nz-icon nzType="loading" class="loading-icon" />
            Loading Data...
          </nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Contract Value -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6">Contract Value</nz-form-label>
      <nz-form-control [nzSpan]="18" nzAddOnBefore="$USD">
        <input nz-input formControlName="hardCostCap" placeholder="Project Hard Cost" />
      </nz-form-control>
    </nz-form-item>

    <!-- Task Description -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzRequired>Task</nz-form-label>
      <nz-form-control [nzSpan]="18" nzErrorTip="Please enter task description">
        <input nz-input formControlName="name" placeholder="Enter short description" />
      </nz-form-control>
    </nz-form-item>

    <!-- Priority -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzRequired>Priority</nz-form-label>
      <nz-form-control [nzSpan]="18" nzErrorTip="Please select priority">
        <nz-select formControlName="priority" nzShowSearch nzAllowClear nzPlaceHolder="Select priority">
          @for (priority of priorityList; track priority.id) {
          <nz-option [nzValue]="priority.id" [nzLabel]="priority.name"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Due Date -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzRequired>Due Date</nz-form-label>
      <nz-form-control [nzSpan]="18" nzErrorTip="Please select due date">
        <nz-date-picker formControlName="due_date" nzPlaceHolder="Select due date" class="w-100"
          [nzDisabledDate]="disabledPastDate">
        </nz-date-picker>
      </nz-form-control>
    </nz-form-item>

    <!-- Description -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzRequired>Description</nz-form-label>
      <nz-form-control [nzSpan]="18" nzErrorTip="Please enter description">
        <quill-editor theme="snow" placeholder="Enter full task description" class="content-editor"
          [modules]="quillConfig" formControlName="description">
        </quill-editor>
      </nz-form-control>
    </nz-form-item>

    <!-- Status -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzRequired>Status</nz-form-label>
      <nz-form-control [nzSpan]="18" nzErrorTip="Please select status">
        <nz-select nzShowSearch nzAllowClear formControlName="task_status" nzPlaceHolder="Select Status">
          @for (status of listOfTaskStatus; track status.id) {
          <nz-option [nzValue]="status.id" [nzLabel]="status.name"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Assigned to group -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzRequired>Assigned to Group</nz-form-label>
      <nz-form-control [nzSpan]="18" nzErrorTip="Please select group">
        <nz-select nzMode="multiple" nzShowSearch nzAllowClear [nzMaxTagCount]="10" formControlName="assigned_to_group"
          nzPlaceHolder="Select group">
          @for(user of listOfUserGroup; track user.id) {
          <nz-option [nzValue]="user.id" [nzLabel]="user.name"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Assigned to -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" >Assigned To</nz-form-label>
      <nz-form-control [nzSpan]="18" nzErrorTip="Please select assignee">
        <nz-select nzMode="multiple" nzShowSearch nzAllowClear nzServerSearch (nzOnSearch)="onSearchMember($event)"
        (nzOpenChange)="onAssignToDropdownChange($event)"
          [nzMaxTagCount]="10" formControlName="assigned_to" nzPlaceHolder="Select person">
          @for(user of listOfUser; track user.id) {
          <nz-option [nzValue]="user.id" [nzLabel]="`${user.name}`"></nz-option>
          }
        </nz-select>

        <!-- <nz-select nzShowSearch nzServerSearch  (nzOnSearch)="onSearchMember($event)" (nzOpenChange)="onAssignToDropdownChange($event)" nzMode="multiple"  
        [nzMaxTagCount]="10" [nzAllowClear]="true" formControlName="assign_to" nzPlaceHolder="Select a person">
          @for(user of listOfUser; track user.id) {
            <nz-option [nzValue]="user.id" [nzLabel]="`${user.name}`"></nz-option>
          }
        </nz-select> -->

      </nz-form-control>
    </nz-form-item>



    <!-- Additional Files -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6">Additional Files</nz-form-label>
      <nz-form-control [nzSpan]="18" class="fileUpload">
        <nz-upload [nzSize]="5242880" [nzCustomRequest]="customUploadRequest" nzListType="picture"
          [nzBeforeUpload]="beforeUpload" (nzChange)="onUploadChange($event)" [(nzFileList)]="fileList">
          <button nz-button>
            <i nz-icon nzType="paper-clip"></i> Attach Files
          </button>
        </nz-upload>
        <p style="font-size:10px;font-weight: 500;font-style: italic;color:grey;
          position:absolute;right:10px;top:6px"> Accepted formats: .pdf, .jpeg, .jpg etc. (Add max file size 5 MB)</p>
      </nz-form-control>
    </nz-form-item>
  </form>

  <ng-template #footerTpl>
    <div style="float: right">
      <button nz-button style="margin-right: 8px;" (click)="closeonly()">Cancel</button>
      <button nz-button nzType="primary" (click)="submitTaskForm()"> {{ data ? 'Update' : 'Create' }} </button>
      <!-- <button nz-button nzType="primary" (click)="submitTaskForm()" [disabled]="!taskForm.valid">Create</button> -->
    </div>
  </ng-template>
</nz-drawer>